// extracted by mini-css-extract-plugin
export default {"browser-frame":"DMcza5","browserFrame":"DMcza5","browser-frame-content":"i8uq5R","browserFrameContent":"i8uq5R"};